import { claimFails } from '@cyberscore/contracts';
import { FileX2, ShieldCheck } from 'lucide-react';
import { href } from '../../lib/router';
import { useQuestions } from '../assessments/api';
import { useClaims } from './api';
import { ClaimList } from './ClaimList';

/**
 * For the business (task 62): answers its own documents contradict, to change or explain, and how many
 * its documents back. Nothing shows until an answer has been checked.
 */
export function ClaimsCard({ id, canChange }: { id: string; canChange: boolean }) {
  const claims = useClaims(id);
  const qs = useQuestions(id);
  if (!claims.data) return null;
  const { summary, results } = claims.data;
  const text = (k: string) => qs.data?.questions.find((q) => q.key === k)?.definition.text ?? k;
  const contradicted = Object.keys(summary).filter((k) => summary[k] === 'contradicted');
  const backed = Object.keys(summary).filter((k) => summary[k] === 'supported').length;
  const unbacked = Object.keys(summary).filter((k) => summary[k] !== 'contradicted' && claimFails(summary[k]!)).length; // prettier-ignore
  if (!contradicted.length && !backed && !unbacked) return null;

  return (
    <section className="card pad" aria-labelledby="claims-h">
      <h2 id="claims-h" className="section-title row gap">
        {contradicted.length ? <FileX2 size={17} className="bad-t" /> : <ShieldCheck size={17} className="ok-t" />}
        {contradicted.length
          ? `Your documents say something different (${contradicted.length})`
          : 'Your answers, checked against your documents'}
      </h2>
      <p className="muted small">
        {backed > 0 && `${backed} ${backed === 1 ? 'answer is' : 'answers are'} backed by your documents, which counts for more in your score. `}
        {unbacked > 0 && `${unbacked} ${unbacked === 1 ? 'isn’t' : 'aren’t'} shown in any document yet; uploading one helps. `}
        {contradicted.length > 0 && 'Your insurer sees where a document disagrees. Change the answer if it’s out of date, or tell them why it’s right.'}
      </p>
      {contradicted.length > 0 && (
        <ul className="review-list">
          {contradicted.map((k) => (
            <li key={k} className="card pad stack-sm">
              <div className="qtext">{text(k)}</div>
              <ClaimList claims={results.filter((r) => r.question_key === k && r.verdict === 'contradicted')} />
              <div className="row gap wrap">
                {canChange && (
                  <a className="btn btn-sm" href={href.answer(id, k)}>
                    Change the answer
                  </a>
                )}
                <a className="btn btn-sm btn-ghost" href={href.messages(id, k)}>
                  Explain to your insurer
                </a>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  ); // prettier-ignore
}
